module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c252c7ab1395a3a602cbcaeb19e6b928.png";